import { combineReducers } from 'redux';
import { AuthType } from '../../types/response';
import auth from './auth.reducer';
import { alertReducer as alerts, Alert } from '../../components/alert-info';
import theme, { ThemeState } from './theme.reducer';
import settings, { SettingsState } from './settings';

export type State = {
  auth: AuthType;
  theme: ThemeState;
  alerts: Alert[];
  settings: SettingsState;
};

export default combineReducers({ auth, theme, alerts, settings });
